import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { normalizeInstalledIntegrations } from './normalize-installed-integrations.js'

export function getInstalledIntegrations(
  config: ResolvedBetterstartConfig
): BetterstartIntegrationId[] {
  return normalizeInstalledIntegrations(config)
}
